// Brand artwork for the admin console (CB-12, INF-1). Lives in theme/ with the rest of
// the white-label bundle: a different tenant swaps these PNGs (and tokens.ts `brand`),
// nothing else in the surface changes. Copied from the admin design export
// (claude-design-raw-html/admin-dashboard/brand/logo-en*.png, the sign-in page's
// `logoSrc`) — a light lockup and a reversed one for the dark theme; theme.css decides
// which one shows.
import lockup from './assets/brand-lockup.png';
import lockupReversed from './assets/brand-lockup-rev.png';

export const brandAssets = {
  /** Full lockup for light surfaces. */
  lockup,
  /** Reversed lockup for dark surfaces. */
  lockupReversed,
} as const;
